import { render, staticRenderFns } from "./MarketingSalesDetailChannelSegment.vue?vue&type=template&id=adafe6d2&"
import script from "./MarketingSalesDetailChannelSegment.vue?vue&type=script&lang=js&"
export * from "./MarketingSalesDetailChannelSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports